import { render, staticRenderFns } from "./payrollaccuralReco.vue?vue&type=template&id=2acb8721"
import script from "./payrollaccuralReco.vue?vue&type=script&lang=js"
export * from "./payrollaccuralReco.vue?vue&type=script&lang=js"
import style0 from "./payrollaccuralReco.vue?vue&type=style&index=0&id=2acb8721&prod&lang=css"
import style1 from "./payrollaccuralReco.vue?vue&type=style&index=1&id=2acb8721&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports